const CONSTANTS = {
	// Login request 
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	LOGIN_FAILURE: 'LOGIN_FAILURE',

	// for sing-up
	SINGUP_REQUEST: 'SINGUP_REQUEST',
	SINGUP_SUCCESS: 'SINGUP_SUCCESS',
	SINGUP_FAILURE: 'SINGUP_FAILURE',

	// global State
	GLOBAL_STATE_KEY_REQUEST: 'GLOBAL_STATE_KEY_REQUEST',
	TOGGLE_FOOTER: 'TOGGLE_FOOTER',

	// HANDLE EVENT LOGS

	ADD_EVENT_LOG_REQUEST: 'ADD_EVENT_LOG_REQUEST',
	ADD_EVENT_LOG_SUCCESS: 'ADD_EVENT_LOG_SUCCESS',
	ADD_EVENT_LOG_FAILURE: 'ADD_EVENT_LOG_FAILURE',

	//EVENT ACTION CONSTANTS
	EVENT_INITIAL_REQUEST: 'EVENT_INITIAL_REQUEST',
	EVENT_INITIAL_SUCCESS: 'EVENT_INITIAL_SUCCESS',
	EVENT_INITIAL_FAILURE: 'EVENT_INITIAL_FAILURE',
	UPDATE_EVENT_STATE: 'UPDATE_EVENT_STATE',

	//PASS ACTION CONSTANTS
	PASS_INITIAL_REQUEST: 'PASS_INITIAL_REQUEST',
	PASS_INITIAL_SUCCESS: 'PASS_INITIAL_SUCCESS',
	PASS_INITIAL_FAILURE: 'PASS_INITIAL_FAILURE',
	//  update user profile 
	UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
	UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
	UPDATE_USER_PROFILE_FAILURE: 'UPDATE_USER_PROFILE_FAILURE',

	//  get user profile 
	GET_USER_PROFILE_REQUEST: 'GET_USER_PROFILE_REQUEST',
	GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
	GET_USER_PROFILE_FAILURE: 'GET_USER_PROFILE_FAILURE',

	//  get user Data 
	GET_USER_DATA_REQUEST: 'GET_USER_DATA_REQUEST',
	GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
	GET_USER_DATA_FAILURE: 'GET_USER_DATA_FAILURE',

	// Reset Password
	POST_RESET_PASSWORD_REQUEST: 'POST_RESET_PASSWORD_REQUEST',
	POST_RESET_PASSWORD_SUCCESS: 'POST_RESET_PASSWORD_SUCCESS',
	POST_RESET_PASSWORD_FAILURE: 'POST_RESET_PASSWORD_FAILURE',

	// GET PARTNER DETAILS
	GET_PARTNER_DETAILS_BY_SLUG_REQUEST: 'GET_PARTNER_DETAILS_BY_SLUG_REQUEST',
	GET_PARTNER_DETAILS_BY_SLUG_SUCCESS: 'GET_PARTNER_DETAILS_BY_SLUG_SUCCESS',
	GET_PARTNER_DETAILS_BY_SLUG_FAILURE: 'GET_PARTNER_DETAILS_BY_SLUG_FAILURE',

	// APPLY PROMOCODE
	APPLY_PROMOCODE_REQUEST: 'APPLY_PROMOCODE_REQUEST',
	APPLY_PROMOCODE_SUCCESS: 'APPLY_PROMOCODE_SUCCESS',
	APPLY_PROMOCODE_FAILURE: 'APPLY_PROMOCODE_FAILURE',

	SESSION_EVENT_REQUEST: 'SESSION_EVENT_REQUEST',
	SESSION_EVENT_COMPLETE: 'SESSION_EVENT_COMPLETE',

	//booking before payment ACTION CONSTANTS
	BEFORE_PAYMENT_INITIAL_REQUEST: 'BEFORE_PAYMENT_INITIAL_REQUEST',
	BEFORE_PAYMENT_INITIAL_SUCCESS: 'BEFORE_PAYMENT_INITIAL_SUCCESS',
	BEFORE_PAYMENT_INITIAL_FAILURE: 'BEFORE_PAYMENT_INITIAL_FAILURE',

	//booking after payment ACTION CONSTANTS
	AFTER_PAYMENT_INITIAL_REQUEST: 'AFTER_PAYMENT_INITIAL_REQUEST',
	AFTER_PAYMENT_INITIAL_SUCCESS: 'AFTER_PAYMENT_INITIAL_SUCCESS',
	AFTER_PAYMENT_INITIAL_FAILURE: 'AFTER_PAYMENT_INITIAL_FAILURE',

	//AFTER PAYMENT ACTION DOWNLOAD QR CONSTANTS
	QRCODE_REQUEST: 'QRCODE_REQUEST',
	QRCODE_REQUEST_SUCCESS: 'QRCODE_REQUEST_SUCCESS',
	QRCODE_REQUEST_FAILURE: 'QRCODE_REQUEST_FAILURE',

	//CONSTANTS FOR PROMOCODE USAGES
	GET_PROMOCODE_USAGE_REQUEST: 'GET_PROMOCODE_USAGE_REQUEST',
	GET_PROMOCODE_USAGE_SUCCESS: 'GET_PROMOCODE_USAGE_SUCCESS',
	GET_PROMOCODE_USAGE_FAILURE: 'GET_PROMOCODE_USAGE_FAILURE',


	// send email for forgot password request
	SEND_EMAIL_RESET_PASSWORD_REQUEST: 'SEND_EMAIL_RESET_PASSWORD_REQUEST',
	SEND_EMAIL_RESET_PASSWORD_SUCCESS: 'SEND_EMAIL_RESET_PASSWORD_SUCCESS',
	SEND_EMAIL_RESET_PASSWORD_FAILURE: 'SEND_EMAIL_RESET_PASSWORD_FAILURE',


	// nonce payment Gateway
	NONCE_TYPE_PAYMENT_REQUEST: 'NONCE_TYPE_PAYMENT_REQUEST',
	NONCE_TYPE_PAYMENT_SUCCESS: 'NONCE_TYPE_PAYMENT_SUCCESS',
	NONCE_TYPE_PAYMENT_FAILURE: 'NONCE_TYPE_PAYMENT_FAILURE',

	// card list constant 
	GET_CARD_LIST_REQUEST: 'GET_CARD_LIST_REQUEST',
	GET_CARD_LIST_SUCCESS: 'GET_CARD_LIST_SUCCESS',
	GET_CARD_LIST_FAILURE: 'GET_CARD_LIST_FAILURE',

	//  filtered Event Data

	GET_FILTERED_EVENT_DATA_REQUEST: 'GET_FILTERED_EVENT_DATA_REQUEST',
	GET_FILTERED_EVENT_DATA_SUCCESS: 'GET_FILTERED_EVENT_DATA_SUCCESS',
	GET_FILTERED_EVENT_DATA_FAILURE: 'GET_FILTERED_EVENT_DATA_FAILURE',


	RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
	RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
	RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',

	YEAR_PASS: 'Year_Pass',
	FULLSEASON: 'USM_Pass',

	GET_VEHICLE_LIST_REQUEST: 'GET_VEHICLE_LIST_REQUEST',
	GET_VEHICLE_LIST_SUCCESS: 'GET_VEHICLE_LIST_SUCCESS',
	GET_VEHICLE_LIST_FAILURE: 'GET_VEHICLE_LIST_FAILURE',
	GET_VEHICLE_MODEL_REQUEST: 'GET_VEHICLE_MODEL_REQUEST',
	GET_VEHICLE_MODEL_SUCCESS: 'GET_VEHICLE_MODEL_SUCCESS',
	GET_VEHICLE_MODEL_FAILURE: 'GET_VEHICLE_MODEL_FAILURE',

	PASS_DOWNLOAD_REQUEST: 'PASS_DOWNLOAD_REQUEST',
	PASS_DOWNLOAD_SUCCESS: 'PASS_DOWNLOAD_SUCCESS',
	PASS_DOWNLOAD_FAILURE: 'PASS_DOWNLOAD_FAILURE',
}
export default CONSTANTS
